import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedContent from './components/FeaturedContent';
import UpdateRanking from './components/UpdateRanking';
import PlatformComparison from './components/PlatformComparison';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedContent />
        <UpdateRanking />
        <PlatformComparison />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}